export const USER_UNKNOWN_ERROR = "Something went wrong!";
